@if (visible()) {
  <!-- Two buttons, not one: `[mibMenuTrigger]` toggles the panel on the host's own click listener. -->
  @if (menuMode()) {
    <button
      mibButton
      class="shrink-0 whitespace-nowrap"
      [size]="size()"
      [disabled]="pending()"
      [attr.aria-label]="accessibleLabel()"
      [mibMenuTrigger]="roomMenu">
      @if (pending()) {
        <mib-spinner size="sm" color="light"></mib-spinner>
      } @else {
        <svg mib-icon name="video"></svg>
      }
      @if (!notExpanded()) {
        New live
      }
      <svg mib-icon name="chevron-down" class="size-4"></svg>
    </button>

    <!-- Declared after its trigger, which is what lets the trigger register before it renders. -->
    <mib-menu
      #roomMenu
      align="end"
      [menuItems]="menuItems()"
      (itemSelected)="startLive($event)"></mib-menu>
  } @else {
    <button
      mibButton
      class="shrink-0 whitespace-nowrap"
      [size]="size()"
      [disabled]="!canStart() || pending()"
      [attr.aria-label]="accessibleLabel()"
      (click)="startFirstAvailable()">
      @if (pending()) {
        <mib-spinner size="sm" color="light"></mib-spinner>
      } @else {
        <svg mib-icon name="video"></svg>
      }
      @if (!notExpanded()) {
        New live
      }
    </button>
  }
}
